import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    prodotto: null,
    saved: false,
    refresh: false
  },
  getters: {
    prodotto: state => state.prodotto,
    saved: state => state.saved,
    refresh: state => state.refresh
  },
  mutations: {
    SET_PRODOTTO (state, payload) {
      state.prodotto = payload
    },
    CLEAR_PRODOTTO (state) {
      state.prodotto = null
    },
    SET_PRODOTTO_SAVED (state) {
      state.saved = true
    },
    CLEAR_PRODOTTO_SAVED (state) {
      state.saved = false
    },
    SET_REFRESH (state) {
      state.refresh = true
    },
    CLEAR_REFRESH (state) {
      state.refresh = false
    }
  },
  actions: {
  }
}
